import { render } from "./ManageSDVRuleList.vue?vue&type=template&id=6cf637fe&scoped=true"
import script from "./ManageSDVRuleList.js?vue&type=script&lang=js"
export * from "./ManageSDVRuleList.js?vue&type=script&lang=js"

import "./ManageSDVRuleList.vue?vue&type=style&index=0&id=6cf637fe&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cf637fe"]])

export default __exports__